<template>
  <el-menu style="min-height: 100%; overflow-x: hidden"
           background-color="rgb(48, 65, 86)"
           text-color="#fff"
           active-text-color="#ffd04b"
           :collapse-transition="false"
           :collapse="isCollapse"
  >
    <div style="height: 60px; line-height: 60px; text-align: center">
      <img src="../assets/TianSheng.png" alt="" style="width: 20px; position: relative; top: 5px;">
      <b style="color: white; margin-left: 5px" v-show="logoTextShow">后台管理系统</b>
    </div>
    <div v-for="item in menus" :key="item.id">
      <div v-if="item.path">
        <el-menu-item :index="item.path" @click="handleSubMenuClick(item.path)">
          <i :class="item.icon"></i>
          <span slot="title">{{ item.name }}</span>
        </el-menu-item>
      </div>
      <div v-else>
        <!-- 使用 el-popover 替代 el-submenu -->
        <el-popover
            placement="right"
            trigger="hover"
            :disabled="isCollapse"
        >
          <div>
            <el-row :gutter="10" v-if="item.children.filter(item => item.children).length === 0">
              <el-col 
                v-for="(col, colIndex) in calculateColumns(item.children)" 
                :key="colIndex" 
                :span="calculateSpan(item.children.length)"
                style="width: 150px;border-right: 1px solid #eee; padding: 10px; overflow: hidden"
                :style="{ borderRight: colIndex === calculateColumns(item.children).length - 1 ? 'none' : '1px solid #eee' }"
              >
                <div 
                  v-for="(subItem, subIndex) in col" 
                  :key="subIndex"
                  style="margin-bottom: 5px;height: 40px"
                  @click="handleSubMenuClick(subItem.path)"
                  class="submenu-item"
                >
                  <i :class="subItem.icon" style="line-height: 40px"></i>
                  <span style="font-size: 15px;line-height: 40px">
                    {{ subItem.name }}
                  </span>
                </div>
              </el-col>
            </el-row>
            <el-row v-else :style="{width:item.children.length * 180 + 'px'}">
              <el-col
                  v-for="(child,index) in item.children" :span="24/item.children.length"
                  :style="{borderRight:index === item.children.length - 1 ? 'none' : '1px solid #eee',paddingLeft:'10px'}"
              >
                <el-row style="padding-bottom: 20px;">
                  <i :class="child.icon" style="line-height: 50px"></i>
                  <span style="font-size: 17px;line-height: 50px">{{child.name}}</span>
                </el-row>
                <el-row>
                  <el-col
                      v-for="(col, colIndex) in calculateColumns(child.children)"
                      :key="colIndex"
                      :span="calculateSpan(child.children.length)"
                      style="width: 150px;border-right: 1px solid #eee; padding: 10px; overflow: hidden"
                      :style="{ borderRight: colIndex === calculateColumns(child.children).length - 1 ? 'none' : '1px solid #eee' }"
                  >
                    <div
                        v-for="(subItem, subIndex) in col"
                        :key="subIndex"
                        style="margin-bottom: 5px;height: 40px"
                        @click="handleSubMenuClick(subItem.path)"
                        class="submenu-item"
                    >
                      <i :class="subItem.icon" style="line-height: 40px"></i>
                      <span style="font-size: 15px;line-height: 40px">
                        {{ subItem.name }}
                      </span>
                    </div>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
          <el-menu-item slot="reference" :index="item.id + ''">
            <i :class="item.icon"/>
            <span slot="title">{{ item.name }}</span >
            <!-- 添加展开箭头图标 -->
            <i class="el-icon-arrow-right" style="position: absolute; right: 20px; top: 50%; transform: translateY(-50%);"></i>
          </el-menu-item>
        </el-popover>
      </div>
    </div>
  </el-menu>
</template>

<script>
import {appendSystemMenus} from "@/router";

export default {
  name: "Aside",
  props: {
    isCollapse: Boolean,
    logoTextShow: Boolean
  },
  data() {
    return {
      menus: localStorage.getItem("menus") ? appendSystemMenus(JSON.parse(localStorage.getItem("menus"))) : [],
      subMenuForm: {} // 用于绑定子菜单数据
    }
  },
  mounted() {

  },
  methods: {
    handleSubMenuClick(path) {
      this.$router.push(path); // 处理子菜单点击事件
    },
    // 计算列数，每列最多10行
    calculateColumns(children) {
      if (!children || children.length === 0) return [];
      
      const columns = [];
      const maxRows = 10;
      const totalItems = children.length;
      const totalColumns = Math.ceil(totalItems / maxRows);
      
      for (let i = 0; i < totalColumns; i++) {
        const start = i * maxRows;
        const end = Math.min(start + maxRows, totalItems);
        columns.push(children.slice(start, end));
      }
      
      return columns;
    },
    // 计算每列的span值
    calculateSpan(totalItems) {
      const maxRows = 10;
      const totalColumns = Math.ceil(totalItems / maxRows);
      return Math.floor(24 / totalColumns);
    }
  }

}
</script>

<style>
.el-menu-item.is-active {
  background-color: rgb(38, 52, 69) !important;
}
.el-menu-item:hover {
  background-color: rgb(38, 52, 69) !important;
}

.el-submenu__title:hover {
  background-color: rgb(38, 52, 69) !important;
}
/*解决收缩菜单文字不消失问题*/
.el-menu--collapse span {
  visibility: hidden;
}

/* 添加子菜单项悬浮效果 */
.submenu-item {
  transition: background-color 0.3s;
  padding: 0 10px;
  border-radius: 4px;
}
.submenu-item:hover {
  background-color: rgba(64, 158, 255, 0.1);
  cursor: pointer;
}
</style>

